import { render, staticRenderFns } from "./report-student-multi.vue?vue&type=template&id=071dc16a"
import script from "./report-student-multi.vue?vue&type=script&lang=js"
export * from "./report-student-multi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports